export default __webpack_public_path__ + "static/media/tesla.45336091.png";